import { CiEdit } from "react-icons/ci";

import { Stack } from "@mui/material";
import { Alert, Button, Card, Modal, Tooltip } from "antd";
import listTables from "../../tableTitles.json";
import { useState } from "react";
import { IoExitOutline } from "react-icons/io5";
import { RxFileText } from "react-icons/rx";
import { formatCNPJ, limitarTexto25 } from "../../../../../../../function/utilis/function";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import { LuContact } from "react-icons/lu";

import "./style.css"
import ExportTarefasPendentesEmitidas from "../../../ExportExcelDinamico/ExportTarefasPendentesEmitidas";
import Contexto from "../../Contexto";

export function TabelasEmitidas({
  showPendentes,
  slicedData,
  handleModalEmitirOpen,
  handleFileId,
  handleEmitidasEditarOpen,
  listTableTarefasPendentes,
  listTableTarefasEmitidas
}) {
  const [titleTable] = useState(listTables);

  const [isMOdalExport, setIsMOdalExport] = useState(false);
  const [isModalContexto, setIsModalContexto] = useState(false);
  const [selectedIdCliente, setSelectedIdCliente] = useState(null);

  return (
    <>

      {(showPendentes ? listTableTarefasPendentes.length > 0 : listTableTarefasEmitidas.length > 0) && (
        <Tooltip title={showPendentes ? "Exportar tarefas Pendentes" : "Exportar tarefas Emitidas"}>
          <div className="pin-excel" onClick={() => setIsMOdalExport(true)}>
            <PiMicrosoftExcelLogoFill />
          </div>
        </Tooltip>
      )}

      <div className="tabela-container">
        <div
          className={`tabela-header-pendentes-emitidas ${showPendentes ? "grip-column-emitidas" : "grip-column-pendente"
            }`}
        >
          {showPendentes
            ? titleTable[0].titles.map((item, index) => (
              <div
                className="col"
                style={{ textAlign: item.title === "Acessar" ? "center" : undefined }}
              >
                {item.title}
              </div>
            ))
            : titleTable[1].titles.map((item, index) => (
              <div
                className="col"
                style={{ textAlign: item.title === "Acessar" ? "center" : undefined }}
              >
                {item.title}
              </div>
            ))}
        </div>
        <div className="tabela-grid">
          {slicedData.length > 0 ? (
            slicedData.map((item, index) => {
            return (
              <>
                <Card
                  key={index}
                  size="small"
                  hoverable
                  className={`tabela-card-pendentes-emitidas ${item.situacao?.nome === "Emitida"
                      ? "color-verde"
                      : item.situacao?.nome === "Justificada"
                        ? "color-azul-claro"
                        : item.situacao?.nome === "Sem Movimento" 
                        ? "color-laranja" 
                        : ""
                    }`}>

                  <div className={`tabela-linha-pendentes-emitidas ${showPendentes ? "grip-column-emitidas" : "grip-column-pendente"}`}>
                    <div className="col"><span>{item.cliente.id}</span></div>
                    <div className="col"><span>{item.cliente.carteira.id}/{item.cliente.equipe.id}</span></div>
                    <div className="col"><span>{formatCNPJ(item.cliente.cnpj)}</span></div>
                    <Tooltip title={item.cliente.nome}>
                      <div className="col"><span>{limitarTexto25(item.cliente.nome)}</span></div>
                    </Tooltip>
                    {showPendentes ? (
                      <div className="col" style={{ display: "flex", justifyContent: "center" }}>
                        <div
                          className="btn-acesso"
                          onClick={() =>
                            handleModalEmitirOpen(
                              item.cliente.id,
                              item.obrigacao.id,
                              item
                            )
                          }
                        >
                          <IoExitOutline />
                        </div>
                      </div>
                    ) : (
                        <>
                          <div className="col">
                            <span>{item.situacao?.nome}</span>
                            {item.liberado === false && <span> (Não Liberado)</span>}
                          </div>

                          <div className="col" style={{display: "flex"}}>
                            <Tooltip title="Contatos do cliente">
                              <div
                                className="btn-acesso"
                                onClick={() => {
                                  setSelectedIdCliente(item.cliente.id); // salva idCliente
                                  setIsModalContexto(true); // abre modal
                                }}
                              >
                                <LuContact />
                              </div>
                            </Tooltip>

                            <Tooltip title="Arquivos">
                              <div
                                className="btn-acesso"
                                onClick={() => handleFileId(item)}
                              >
                                <RxFileText />
                              </div>
                            </Tooltip>
                            <Tooltip title="Editar">
                              <div
                                className="btn-acesso"
                                onClick={() =>
                                  handleEmitidasEditarOpen(item.id, item.obrigacao.id)
                                }
                              >
                                <CiEdit />
                              </div>
                            </Tooltip>
                          </div>
                        </>
                    )}
                  </div>
                </Card>
              </>
              )
            })
          ) : (
 
              <Alert message={showPendentes ? "Tarefa Finalizada!" : "Emitidas"} type={showPendentes ? "success" : "info"} description={showPendentes
                ? "Não há itens pendentes para esta tarefa."
                : "Lista de tarefas emitidas"} />
          )}
        </div>
      </div>

      <Modal
        width="50%"
        title="Selecionar colunas para exportar"
        open={isMOdalExport}
        onCancel={() => setIsMOdalExport(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsMOdalExport(false)}>
            Cancelar
          </Button>
        ]}
      >
        <ExportTarefasPendentesEmitidas slicedData={showPendentes ? listTableTarefasPendentes : listTableTarefasEmitidas} />
      </Modal>

      <Modal
        width="70%"
        title="Agenda de contatos do cliente"
        open={isModalContexto}
        onCancel={() => setIsModalContexto(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalContexto(false)}>
            Cancelar
          </Button>
        ]}
      >
        <Contexto setIsModalContexto={setIsModalContexto} idCliente={selectedIdCliente} selectedIdCliente={selectedIdCliente} />
      </Modal>
    </>
  );
}

export default TabelasEmitidas;
